export const styles = theme => ({
    productDetails: {
        marginTop: 64,
    },
    productExplanation: {
        "& img": {
            height: 32,
            marginBottom: 15,
            marginRight: 10,
        },
        "& h2": {
            fontSize: 34,
            fontWeight: 700,
            marginBottom: 32,
        },
        "& h4": {
            fontSize: 20,
            fontWeight: 800,
            color: "rgba(0,0,0,0.87)",
            marginBottom: 12,
        },
        "& p": {
            fontSize: 16,
            marginBottom: 29,
        }
    },
    otherProducts: {
        marginTop: 177,
        marginBottom: 24,
        textAlign: "center",
        fontSize: 34,
        fontWeight: 700,
    } as const,
    section: {
        "& h2": {
            margin: "32px 0",
        }
    },
    instrumentBox: {
        marginTop: 32,
    }
});